module.exports = __webpack_public_path__ + "img/badge.d4f2848e.jpg";